import { render } from "./BaseNavigationCard.vue?vue&type=template&id=3bd001d2&scoped=true"
import script from "./BaseNavigationCard.vue?vue&type=script&lang=js"
export * from "./BaseNavigationCard.vue?vue&type=script&lang=js"

import "./BaseNavigationCard.vue?vue&type=style&index=0&id=3bd001d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd001d2"]])

export default __exports__